var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"container"},[_c('el-col',{attrs:{"span":4}},[_vm._v("LOGO")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_vm._v("客户工程师接待系统")]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_vm._v("\n    你好，"+_vm._s(this.realName)+" "),_c('span',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("注销")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00623367","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = null
// module chunks = 